.text
  h1
    color: var(--c-text-01);
